import { format } from "date-fns";

export const ddMMyyyy = "dd/MM/yyyy";
export const ddMMyyyyHHMMSS = "dd/MM/yyyy HH:MM:SS";

export const toDDMMYYYY = (date) => {
    if(date)
        return format(date, ddMMyyyy);
    return date;
}

export const toDDMMYYYYHHMMSS = (date) => {
    if(date)
        return format(date, ddMMyyyyHHMMSS);
    return date;
}
